<template>
  <div v-if="item">
    <h5>Создано: {{ item.created_at | dateTimeFormat }}</h5>
    <h5>Пользователь: {{ item.user.name }}</h5>
    <!-- <br /> -->
    <!-- <h6 class="text-primary" @click="refresh">
      Статус: {{ statuses[item.status] ? statuses[item.status] : item.status }}
      <span class="ti-reload ml-2"></span>
    </h6> -->

    <hr />
    <h4>Документы</h4>
    <ul>
      <li v-for="medium in item.media" :key="medium.id">
        <h5>
          <a target="_blank" :href="medium.original_url" class="link">
            <b> {{ medium.collection_name }}:</b> {{ medium.name }}
            <span class="ti-upload ml-2"></span
          ></a>
        </h5>
      </li>
    </ul>
  </div>
</template>

<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    statuses: {
      started: "В процессе",
      cancel: "Отыменено",
      done: "Выполнено",
    },
    cardLink: "registry_reports",
    cardSetLink: "registry_reports",
    item: null,
    fields: [
      {
        col: " col-12 col-md-6",
        key: "status",
        label: "Название",
        type: "field",
        textType: "text",
      },
    ],
  }),

  props: ["id"],
  created() {
    this.refresh();
  },
  methods: {
    async refresh() {
      this.item = await this.cardContent(this.cardLink, this.id);
    },
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );
    },
  },
};
</script>
<style>
</style>
